// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  EmptyTrashPayload,
  EmptyTrashPayloadFromJSON,
  EmptyTrashPayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
  TrashActionResult,
  TrashActionResultFromJSON,
  TrashActionResultToJSON,
  TrashBulkRestorePayload,
  TrashBulkRestorePayloadFromJSON,
  TrashBulkRestorePayloadToJSON,
  TrashItem,
  TrashItemFromJSON,
  TrashItemToJSON,
} from "../models";

export interface EmptyTrashRequest {
  emptyTrashPayload: EmptyTrashPayload;
  project: number;
}

export interface GetTrashItemsRequest {
  project: number;
  start?: number;
  limit?: number;
}

export interface GetTrashItemsCountRequest {
  project: number;
}

export interface RestoreTrashItemRequest {
  project: number;
  id: number;
}

export interface RestoreTrashItemsRequest {
  trashBulkRestorePayload: TrashBulkRestorePayload;
  project: number;
}

/**
 * no description
 */
export class TrashApi extends runtime.BaseAPI {
  /**
   * Company Administrators only; all plans. Requires an exact EMPTY TRASH confirmation and queues permanent removal of all entries in this project's Trash at request acceptance, including expired entries not yet removed by the daily job. Items deleted after acceptance are not part of this request. Descendants and linked copies retained with an entry are removed with it. This operation cannot be undone. Concurrent restore and purge operations must claim entries exclusively; an item already restored is not removed. The activity log records both the empty request and each final removal.
   * Empty a project's Trash permanently
   */
  async emptyTrashRaw(
    requestParameters: EmptyTrashRequest
  ): Promise<runtime.ApiResponse<TrashActionResult>> {
    if (
      requestParameters.emptyTrashPayload === null ||
      requestParameters.emptyTrashPayload === undefined
    ) {
      throw new runtime.RequiredError(
        "emptyTrashPayload",
        "Required parameter requestParameters.emptyTrashPayload was null or undefined when calling emptyTrash."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling emptyTrash."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trashitems/empty`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: EmptyTrashPayloadToJSON(requestParameters.emptyTrashPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrashActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Company Administrators only; all plans. Requires an exact EMPTY TRASH confirmation and queues permanent removal of all entries in this project's Trash at request acceptance, including expired entries not yet removed by the daily job. Items deleted after acceptance are not part of this request. Descendants and linked copies retained with an entry are removed with it. This operation cannot be undone. Concurrent restore and purge operations must claim entries exclusively; an item already restored is not removed. The activity log records both the empty request and each final removal.
   * Empty a project's Trash permanently
   */
  async emptyTrash(
    requestParameters: EmptyTrashRequest
  ): Promise<TrashActionResult> {
    const response = await this.emptyTrashRaw(requestParameters);
    return await response.value();
  }

  /**
   * Available on all plans to company Administrators only, with access checked in the company that owns the requested project. Project roles and test case delete permissions do not grant Trash access. Lists items still within their 60-day restore period, newest deletion first, then highest Trash entry ID. A suite entry includes the sub-suites and cases moved to Trash with it; those children are not listed separately. Items deleted separately before their parent suite keep their own entries and original expiry times. Linked copies moved with their source are restored with that source, rather than listed as separate entries in destination projects.
   * List a project's Trash
   */
  async getTrashItemsRaw(
    requestParameters: GetTrashItemsRequest
  ): Promise<runtime.ApiResponse<Array<TrashItem>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getTrashItems."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trashitems`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TrashItemFromJSON)
    );
  }

  /**
   * Available on all plans to company Administrators only, with access checked in the company that owns the requested project. Project roles and test case delete permissions do not grant Trash access. Lists items still within their 60-day restore period, newest deletion first, then highest Trash entry ID. A suite entry includes the sub-suites and cases moved to Trash with it; those children are not listed separately. Items deleted separately before their parent suite keep their own entries and original expiry times. Linked copies moved with their source are restored with that source, rather than listed as separate entries in destination projects.
   * List a project's Trash
   */
  async getTrashItems(
    requestParameters: GetTrashItemsRequest
  ): Promise<Array<TrashItem>> {
    const response = await this.getTrashItemsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Counts entries returned by GET /trashitems before pagination, using the same 60-day deadline and suite grouping. Company Administrators only; all plans.
   * Count a project's Trash entries
   */
  async getTrashItemsCountRaw(
    requestParameters: GetTrashItemsCountRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getTrashItemsCount."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trashitems/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Counts entries returned by GET /trashitems before pagination, using the same 60-day deadline and suite grouping. Company Administrators only; all plans.
   * Count a project's Trash entries
   */
  async getTrashItemsCount(
    requestParameters: GetTrashItemsCountRequest
  ): Promise<Count> {
    const response = await this.getTrashItemsCountRaw(requestParameters);
    return await response.value();
  }

  /**
   * Company Administrators only; all plans. Queues restoration of the entry to its original location, preserving IDs, archive state, revisions, test plan results, comments, attachments, tags, requirement links and linked copies. Restoring a suite also restores the descendants deleted with that suite, but does not restore entries deleted separately before it. Restore a separately trashed parent first; a missing parent or conflicting active suite name prevents restoration. The original project and any linked-copy destination must still exist. The deadline and dependencies are checked again in the worker. An entry being restored or permanently removed cannot be claimed by another operation. The queue reports failure if a dependency changes or the deadline passes before the worker claims the entry; it must not report a partial restore as success.
   * Restore an item from Trash
   */
  async restoreTrashItemRaw(
    requestParameters: RestoreTrashItemRequest
  ): Promise<runtime.ApiResponse<TrashActionResult>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling restoreTrashItem."
      );
    }

    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling restoreTrashItem."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trashitems/{id}/restore`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrashActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Company Administrators only; all plans. Queues restoration of the entry to its original location, preserving IDs, archive state, revisions, test plan results, comments, attachments, tags, requirement links and linked copies. Restoring a suite also restores the descendants deleted with that suite, but does not restore entries deleted separately before it. Restore a separately trashed parent first; a missing parent or conflicting active suite name prevents restoration. The original project and any linked-copy destination must still exist. The deadline and dependencies are checked again in the worker. An entry being restored or permanently removed cannot be claimed by another operation. The queue reports failure if a dependency changes or the deadline passes before the worker claims the entry; it must not report a partial restore as success.
   * Restore an item from Trash
   */
  async restoreTrashItem(
    requestParameters: RestoreTrashItemRequest
  ): Promise<TrashActionResult> {
    const response = await this.restoreTrashItemRaw(requestParameters);
    return await response.value();
  }

  /**
   * Company Administrators only; all plans. Validates the selected entries and creates one restore queue containing every Trash entry ID. The worker restores parent suites before child suites and restores test cases after suites so dependencies selected in the same request are available. The existing single-item restore operation is unchanged. Poll the returned queue for the overall result.
   * Restore multiple items from Trash in one queue
   */
  async restoreTrashItemsRaw(
    requestParameters: RestoreTrashItemsRequest
  ): Promise<runtime.ApiResponse<TrashActionResult>> {
    if (
      requestParameters.trashBulkRestorePayload === null ||
      requestParameters.trashBulkRestorePayload === undefined
    ) {
      throw new runtime.RequiredError(
        "trashBulkRestorePayload",
        "Required parameter requestParameters.trashBulkRestorePayload was null or undefined when calling restoreTrashItems."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling restoreTrashItems."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/trashitems/bulkRestore`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TrashBulkRestorePayloadToJSON(
        requestParameters.trashBulkRestorePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrashActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Company Administrators only; all plans. Validates the selected entries and creates one restore queue containing every Trash entry ID. The worker restores parent suites before child suites and restores test cases after suites so dependencies selected in the same request are available. The existing single-item restore operation is unchanged. Poll the returned queue for the overall result.
   * Restore multiple items from Trash in one queue
   */
  async restoreTrashItems(
    requestParameters: RestoreTrashItemsRequest
  ): Promise<TrashActionResult> {
    const response = await this.restoreTrashItemsRaw(requestParameters);
    return await response.value();
  }
}
